// DripX tank cutaway animation (no libraries). Loops every 14 seconds.
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var T = 14;
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function ss(e0, e1, x) { var t = clamp((x - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); }
  function win(t, a, b, f) { return ss(a, a + f, t) * (1 - ss(b - f, b, t)); }
  function el(tag, attrs, parent) { var n = document.createElementNS(NS, tag); for (var k in attrs) n.setAttribute(k, attrs[k]); if (parent) parent.appendChild(n); return n; }

  function setup(svg) {
    var q = function (k) { return svg.querySelector('[data-ta="' + k + '"]'); };
    var parts = {
      water: q('water'), water2: q('water2'), devmask: q('devmask'), surface: q('surface'), floatcup: q('floatcup'), device: q('device'), glow: q('glow'),
      rings: q('rings'), led: q('led'), flowline: q('flowline'), callout2: q('callout2'), leak: q('leak'), spray: q('spray'), callout: q('callout'), outflow: q('outflow'),
      dot: q('status-dot'), stext: q('status-text'), notify: q('notify'), caustics: q('caustics')
    };
    var ringEls = [0, 1, 2].map(function () { return el('ellipse', { cx: 0, cy: 0, rx: 40, ry: 14, opacity: 0 }, parts.rings); });
    var drops = [];
    for (var i = 0; i < 28; i++) {
      drops.push({ n: el('ellipse', { rx: 2.6, ry: 4.2, fill: '#E9FEFF', opacity: .9 }, parts.leak), x: 590 + Math.random() * 100, o: Math.random(), s: .55 + Math.random() * .6 });
    }
    function wave(x, t, amp) { return Math.sin(x * 0.022 + t * 2.1) * amp + Math.sin(x * 0.047 - t * 1.4) * amp * 0.45; }

    function render(t) {
      t = ((t % T) + T) % T;
      var lvl = ss(3, 8, t) * (1 - ss(10, 11.6, t));
      var L = 292 + 54 * lvl;
      var amp = 3.2 + 1.2 * Math.sin(t * 0.7);
      var d = 'M290 ' + (L + wave(290, t, amp)).toFixed(1), s = d;
      for (var x = 300; x <= 910; x += 10) { var y = (L + wave(x, t, amp)).toFixed(1); d += ' L' + x + ' ' + y; s += ' L' + x + ' ' + y; }
      d += ' L910 600 L290 600Z';
      parts.water.setAttribute('d', d); if (parts.water2) parts.water2.setAttribute('d', d); parts.surface.setAttribute('d', s);
      parts.caustics.setAttribute('transform', 'translate(' + (Math.sin(t * 0.8) * 18).toFixed(1) + ',' + (lvl * 30).toFixed(1) + ')');
      parts.floatcup.setAttribute('y', (L - 30 + wave(357, t, amp) * 0.6).toFixed(1));

      var dx = 548, dy = L + wave(dx, t, amp);
      var tilt = (wave(dx + 30, t, amp) - wave(dx - 30, t, amp)) * 0.35;
      parts.device.setAttribute('transform', 'translate(' + dx + ',' + (dy - 18).toFixed(1) + ') rotate(' + tilt.toFixed(2) + ') scale(.84)');

      if (parts.devmask) parts.devmask.setAttribute('transform', parts.device.getAttribute('transform'));
      var leak = win(t, 3, 10.2, 0.5);
      parts.leak.setAttribute('opacity', leak.toFixed(2));
      parts.outflow.setAttribute('opacity', (leak * 0.95).toFixed(2));
      if (parts.flowline) parts.flowline.setAttribute('stroke-dashoffset', (-t * 60).toFixed(1));
      if (parts.callout2) parts.callout2.setAttribute('opacity', win(t, 4.2, 9.8, 0.5).toFixed(2));
      drops.forEach(function (p) {
        var ph = (t * p.s + p.o) % 1;
        var y = 536 + ph * 60, x = p.x + Math.sin(ph * 6 + p.o * 10) * 3;
        p.n.setAttribute('cx', x.toFixed(1)); p.n.setAttribute('cy', y.toFixed(1)); p.n.setAttribute('opacity', (0.9 * (1 - ph)).toFixed(2));
      });
      parts.callout.setAttribute('opacity', win(t, 3.6, 9.8, 0.5).toFixed(2));
      parts.spray.setAttribute('opacity', win(t, 10, 11.7, 0.3).toFixed(2));

      var det = win(t, 6.6, 10.6, 0.4);
      parts.glow.setAttribute('opacity', (det * (0.6 + 0.3 * Math.sin(t * 5))).toFixed(2));
      ringEls.forEach(function (r, i) {
        var p = ((t * 0.7) + i / 3) % 1, R = 70 + p * 150;
        r.setAttribute('rx', R.toFixed(1)); r.setAttribute('ry', (R * 0.3).toFixed(1));
        r.setAttribute('cy', (8).toString()); r.setAttribute('opacity', (det * (1 - p) * 0.85).toFixed(2));
      });
      var alarm = t >= 6.8 && t < 10.4, fixed = t >= 10.4 && t < 13;
      var blink = alarm ? (Math.sin(t * 10) > 0 ? '#F59E0B' : '#FBBF24') : '#22C55E';
      if (parts.led) parts.led.setAttribute('fill', blink); parts.dot.setAttribute('fill', alarm ? '#F59E0B' : '#22C55E');
      var label = alarm ? 'Silent leak detected' : fixed ? 'Leak fixed' : 'All normal';
      if (parts.stext.textContent !== label) parts.stext.textContent = label;

      var n = ss(7, 7.6, t) * (1 - ss(10.4, 11, t));
      parts.notify.setAttribute('opacity', n.toFixed(2));
      parts.notify.setAttribute('transform', 'translate(' + (1240 - n * 490).toFixed(1) + ',16)');
    }
    return render;
  }

  function start(svg) {
    var render = setup(svg);
    svg.__render = render;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { render(8.6); return; }
    var visible = true, t0 = performance.now();
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(svg);
    (function loop(now) { requestAnimationFrame(loop); if (visible && !window.__tankPaused) render((now - t0) / 1000); })(t0);
  }
  document.querySelectorAll('[data-tank-anim]').forEach(start);
})();
